import { render } from "./InvoiceDisplayModal.vue?vue&type=template&id=3c45e4fa&scoped=true"
import script from "./InvoiceDisplayModal.vue?vue&type=script&lang=js"
export * from "./InvoiceDisplayModal.vue?vue&type=script&lang=js"

import "./InvoiceDisplayModal.vue?vue&type=style&index=0&id=3c45e4fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c45e4fa"]])

export default __exports__